<template>
    <div class="row font-20 font-medium justify-center mb-3">Thông tin thẻ kiểm soát</div>

    <div class="row">
        <div class="xs4">
            <DxValidationGroup ref="formValidationNhomThe">
                <div class="row">
                    <div class="xs12">
                        <DxSelectBox
                            label="Nhóm thẻ (*)"
                            v-model="ThongTinTheKiemSoat.IdNhomThe"
                            :dataSource="{
                                store: DanhSachNhomThe,
                                pageSize: 20,
                                paginate: true,
                            }"
                            display-expr="TenNhomThe"
                            value-expr="IdNhomThe"
                            :search-enabled="true"
                            styling-mode="outlined"
                            no-data-text="Không có dữ liệu!"
                            :onItemClick="onItemClickNhomThe"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                            </DxValidator>
                        </DxSelectBox>
                    </div>
                </div>
            </DxValidationGroup>
            <DxValidationGroup ref="formValidation">
                <div class="row mt-5">
                    <div class="xs12">
                        <DxTextBox
                            label="Tiền tố thẻ (*)"
                            v-model="ThongTinTheKiemSoat.TienTo"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                            valueChangeEvent="keyup"
                            :onValueChanged="onValueChangedTienToHauTo"
                            :disabled="!SuDungKyHieuTuDong"
                            :readOnly="IsDangThemThe"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                                <DxStringLengthRule
                                    :max="10"
                                    message="Không được vượt quá 10 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="xs12">
                        <DxTextBox
                            label="Hậu tố thẻ (*)"
                            v-model="ThongTinTheKiemSoat.HauTo"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                            valueChangeEvent="keyup"
                            :onValueChanged="onValueChangedTienToHauTo"
                            :disabled="!SuDungKyHieuTuDong"
                            :readOnly="IsDangThemThe"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                                <DxStringLengthRule
                                    :max="10"
                                    message="Không được vượt quá 10 ký tự!"
                                />
                                <DxNumericRule message="Hậu tố phải là số!" />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>

                <div class="row mt-4">
                    <DxCheckBox
                        v-model="SuDungKyHieuTuDong"
                        text="Sử dụng ký hiệu tự động"
                    />
                </div>

                <div class="row mt-3">
                    <div class="xs12">
                        <DxTextBox
                            label="Ký hiệu thẻ (*)"
                            v-model="ThongTinTheKiemSoat.KyHieuThe"
                            styling-mode="outlined"
                            validationMessageMode="always"
                            labelMode="floating"
                            :readOnly="SuDungKyHieuTuDong"
                        >
                            <DxValidator>
                                <DxRequiredRule message="Không được bỏ trống!" />
                                <DxStringLengthRule
                                    :max="21"
                                    message="Không được vượt quá 21 ký tự!"
                                />
                            </DxValidator>
                        </DxTextBox>
                    </div>
                </div>
            </DxValidationGroup>

            <div class="row mt-4">
                <div class="xs12">
                    <DxButton
                        v-if="!IsDangThemThe"
                        text="Bắt đầu thêm thẻ"
                        type="default"
                        width="100%"
                        icon="mdi mdi-plus"
                        styling-mode="outlined"
                        @click="BatDauThemThe()"
                    />
                    <DxButton
                        v-if="IsDangThemThe"
                        text="Dừng thêm thẻ"
                        type="danger"
                        width="100%"
                        icon="mdi mdi-pause"
                        styling-mode="outlined"
                        @click="DungThemThe()"
                    />
                </div>
            </div>
            <div class="row mt-3">
                <div class="xs12">
                    <DxButton
                        text="Tải lên file Excel"
                        type="default"
                        width="100%"
                        icon="mdi mdi-table-arrow-up"
                        styling-mode="outlined"
                        @click="UploadExcel()"
                    />
                </div>
            </div>
            <input
                id="input-excel"
                type="file"
                accept=".xlsx,.xls"
                @change="OnChangeUploadExcel"
                style="display: none; position: fixed; left: -1000px"
            />
            <div class="row mt-3">
                <div class="xs12">
                    <DxButton
                        text="Tải xuống mẫu Excel"
                        type="default"
                        width="100%"
                        icon="mdi mdi-download"
                        styling-mode="outlined"
                        @click="TaiMauExcel()"
                    />
                </div>
            </div>
        </div>
        <div class="xs8 ml-4">
            <DxValidationGroup ref="formValidationTable">
                <DxDataGrid
                    ref="DanhSachTheKiemSoat"
                    class="table-page"
                    :show-borders="true"
                    :data-source="ThongTinTheKiemSoat.DanhSachTheKiemSoat"
                    :remote-operations="false"
                    :allow-column-resizing="true"
                    :show-row-lines="true"
                    :column-auto-width="true"
                    :loadPanel="{ showIndicator: false, showPane: false, text: '' }"
                    height="calc(100vh - 96px - 96px - 56px)"
                    no-data-text="Không có dữ liệu!"
                    keyExpr="Id"
                    @cellHoverChanged="onCellHoverChanged"
                >
                    <DxPaging :page-size="20" />
                    <DxScrolling mode="virtual" row-rendering-mode="virtual" />
                    <DxColumnFixing :enabled="true" />
                    <DxHeaderFilter :visible="true" />
                    <DxFilterRow :visible="true" apply-filter="auto" />
                    <DxEditing :allow-updating="true" mode="cell" />
                    <DxColumn
                        :allowEditing="false"
                        data-field="TenNhomThe"
                        caption="Tên nhóm thẻ"
                        :fixed="true"
                        width="250px"
                    />
                    <DxColumn
                        data-field="KyHieuThe"
                        caption="Ký hiệu thẻ"
                        cellTemplate="txtKyHieuThe"
                    />
                    <template #txtKyHieuThe="{ data }">
                        <span
                            :class="
                                data.data.TrungKyHieuThe ? 'color-error font-bold' : ''
                            "
                        >
                            {{ data.data.KyHieuThe }}
                        </span>
                    </template>
                    <DxColumn
                        data-field="MaThe"
                        caption="Mã thẻ"
                        cellTemplate="txtMaThe"
                    />
                    <template #txtMaThe="{ data }">
                        <span
                            :class="data.data.TrungMaThe ? 'color-error font-bold' : ''"
                        >
                            {{ data.data.MaThe }}
                        </span>
                    </template>
                    <DxSummary>
                        <DxTotalItem
                            column="TenNhomThe"
                            summary-type="count"
                            display-format="Tổng: {0}"
                            :show-in-group-footer="true"
                            :align-by-column="true"
                        />
                    </DxSummary>
                    <!-- Hover button -->
                    <DxColumn
                        :allowEditing="false"
                        cssClass="column-button-hover"
                        data-field="Detail"
                        caption="Trạng thái"
                        width="1"
                        cell-template="buttons-cell"
                        :fixed="true"
                        fixedPosition="right"
                    ></DxColumn>
                    <template #buttons-cell="{ data }">
                        <div class="buttons">
                            <DxButton
                                class="mx-1"
                                icon="mdi mdi-delete"
                                @click="XoaTheKiemSoat(data)"
                                hint="Xóa"
                            ></DxButton>
                        </div>
                    </template>
                </DxDataGrid>
            </DxValidationGroup>
        </div>
    </div>

    <div class="row justify-space-between mt-3">
        <DxButton
            type="danger"
            text="Đóng"
            styling-mode="text"
            width="96px"
            @click="Dong"
        />
        <DxButton
            key="mdi-XACNHAN"
            type="default"
            text="Lưu thông tin"
            styling-mode="contained"
            @click="LuuThongTin()"
        />
    </div>
</template>
<script>
import {
    DxDataGrid,
    DxPaging,
    DxScrolling,
    DxColumnFixing,
    DxHeaderFilter,
    DxEditing,
    DxFilterRow,
    DxSelection,
    DxColumn,
    DxSummary,
    DxGroupItem,
    DxTotalItem,
} from "devextreme-vue/data-grid";
import {
    DxCheckBox,
    DxTextBox,
    DxSelectBox,
    DxValidationGroup,
    DxButton,
    DxValidator,
} from "devextreme-vue";
import {
    DxRequiredRule,
    DxStringLengthRule,
    DxNumericRule,
} from "devextreme-vue/validator";
import Devices from "@/functions/Devices.js";
import * as XLSX from "xlsx";
export default {
    components: {
        DxTotalItem,
        DxDataGrid,
        DxPaging,
        DxScrolling,
        DxColumnFixing,
        DxHeaderFilter,
        DxEditing,
        DxFilterRow,
        DxSelection,
        DxColumn,
        DxSummary,
        DxGroupItem,
        DxCheckBox,
        DxSelectBox,
        DxTextBox,
        DxValidationGroup,
        DxButton,
        DxValidator,
        DxRequiredRule,
        DxStringLengthRule,
        DxNumericRule,
    },
    data() {
        return {
            DanhSachNhomThe: [],
            SuDungKyHieuTuDong: true,
            IsDangThemThe: false,
            NhomTheDangChon: null,
        };
    },
    computed: {
        ThongTinTheKiemSoat: {
            get() {
                return this.$store.state.TheKiemSoat.ThongTinTheKiemSoat;
            },
            set(data) {
                this.$store.commit("TheKiemSoat/Set", {
                    key: "ThongTinTheKiemSoat",
                    data: data,
                });
            },
        },
    },
    methods: {
        Dong() {
            this.$emit("hiddenPopup", "PopupThongTinTheKiemSoat");
        },
        onCellHoverChanged(e) {
            this.$Helper.Common.table({ Element: e, Buttons: true }).HoverRow();
        },
        onValueChangedTienToHauTo(e) {
            if (this.SuDungKyHieuTuDong && e.value) {
                this.ThongTinTheKiemSoat.KyHieuThe =
                    (this.ThongTinTheKiemSoat.TienTo || "") +
                    "-" +
                    (this.ThongTinTheKiemSoat.HauTo || "0000");
            }
        },
        onItemClickNhomThe(e) {
            if (e.itemData) {
                this.NhomTheDangChon = e.itemData;
            }
        },
        LuuThongTin() {
            if (this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.length == 0) {
                return this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin thẻ kiểm soát thất bại!",
                    message: "Danh sách thẻ kiểm soát không được để trống!",
                });
            }
            const countMathe = {};
            const countKyhieuthe = {};

            // Bước 1: Đếm số lần xuất hiện của từng MaThe và KyHieuThe
            this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.forEach((item) => {
                countMathe[item.MaThe] = (countMathe[item.MaThe] || 0) + 1;
                countKyhieuthe[item.KyHieuThe] =
                    (countKyhieuthe[item.KyHieuThe] || 0) + 1;
            });

            // Bước 2: Gắn cờ TrungMaThe / TrungKyHieuThe cho phần tử trùng
            this.ThongTinTheKiemSoat.DanhSachTheKiemSoat = this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.map(
                (item) => ({
                    ...item,
                    TrungMaThe: countMathe[item.MaThe] > 1 || false,
                    TrungKyHieuThe: countKyhieuthe[item.KyHieuThe] > 1 || false,
                })
            );
            let checkTrungThongTinThe = this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.some(
                (x) => x.TrungMaThe || x.TrungKyHieuThe
            );
            if (checkTrungThongTinThe) {
                return this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin thẻ kiểm soát thất bại!",
                    message:
                        "Danh sách thẻ kiểm soát có thông tin trùng lặp. Vui lòng kiểm tra lại!",
                });
            }
            this.ThucHienLuuThongTin();
        },
        async ThucHienLuuThongTin() {
            try {
                this.$startLoading;
                let rs;
                rs = await this.$store.dispatch("TheKiemSoat/TaoMoiTheKiemSoat");
                if (rs.status) {
                    this.$Helper.ThongBaoToast(
                        "success",
                        "Lưu thông tin thẻ kiểm soát thành công!"
                    );
                    this.Dong();
                    this.$emit("getData");
                } else {
                    this.$Helper.ThongBaoPopup({
                        message_title: "Lưu thông tin thẻ kiểm soát thất bại!",
                        message: rs.message,
                    });
                }
            } catch (error) {
                console.log("🚀 ~ error:", error);
                this.$Helper.ThongBaoPopup({
                    message_title: "Lưu thông tin thẻ kiểm soát thất bại!",
                    message: "Lỗi hệ thống client.",
                });
            } finally {
                this.$stopLoading;
            }
        },
        async LayDanhSachNhomThe() {
            try {
                this.DanhSachNhomThe = (
                    await this.$store.dispatch("NhomThe/LayDanhSachNhomThe")
                ).Store;
            } catch (error) {
                console.log("🚀 ~ error", error);
            }
        },
        BatDauThemThe() {
            let validateNhomThe = this.$refs.formValidationNhomThe.instance.validate();
            if (!validateNhomThe.isValid) {
                return this.$Helper.Common.autoFocusError(validateNhomThe);
            }
            let validate = this.$refs.formValidation.instance.validate();
            if (!validate.isValid) {
                return this.$Helper.Common.autoFocusError(validate);
            }
            this.IsDangThemThe = !this.IsDangThemThe;
        },
        DungThemThe() {
            this.IsDangThemThe = !this.IsDangThemThe;
        },
        async ThucHienThemThe(MaThe) {
            if (!this.IsDangThemThe) {
                return this.$Helper.ThongBaoToast(
                    "warning",
                    "Vui lòng bấm 'Bắt đầu thêm thẻ' để thêm thẻ!"
                );
            }
            if (!MaThe) {
                return this.$Helper.ThongBaoToast(
                    "error",
                    "Mã thẻ đọc được không hợp lệ!"
                );
            }
            let checkTonTaiMaThe = this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.find(
                (x) => x.MaThe === MaThe
            );
            let checkTonTaiKyHieuThe = this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.find(
                (x) => x.KyHieuThe === this.ThongTinTheKiemSoat.KyHieuThe
            );
            if (checkTonTaiMaThe) {
                this.$Helper.ThongBaoToast(
                    "warning",
                    `Mã thẻ "${MaThe}" đã tồn tại trong danh sách!`
                );
            } else if (checkTonTaiKyHieuThe) {
                this.$Helper.ThongBaoToast(
                    "warning",
                    `Ký hiệu thẻ "${this.ThongTinTheKiemSoat.KyHieuThe}" đã tồn tại trong danh sách!`
                );
            } else {
                this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.push({
                    Id: this.$Helper.Common.randomGUID(),
                    TenNhomThe: this.NhomTheDangChon?.TenNhomThe,
                    IdNhomThe: this.ThongTinTheKiemSoat.IdNhomThe,
                    KyHieuThe: this.ThongTinTheKiemSoat.KyHieuThe,
                    MaThe: MaThe,
                });
            }
            await new Promise((resolve) => setTimeout(resolve, 100));
            this.$refs.DanhSachTheKiemSoat.instance.refresh();
            if (this.SuDungKyHieuTuDong) {
                this.ThongTinTheKiemSoat.HauTo = this.incrementNumericString(
                    this.ThongTinTheKiemSoat.HauTo
                );
            }
        },
        async XoaTheKiemSoat(data) {
            this.ThongTinTheKiemSoat.DanhSachTheKiemSoat = this.ThongTinTheKiemSoat.DanhSachTheKiemSoat.filter(
                (x, i) => i != data.rowIndex
            );
            await new Promise((resolve) => setTimeout(resolve, 100));
            this.$refs.DanhSachTheKiemSoat.instance.refresh();
        },
        incrementNumericString(s) {
            // đảm bảo chỉ chứa chữ số
            if (!/^\d+$/.test(s))
                throw new Error("Input phải là chuỗi chỉ chứa chữ số 0-9");

            // nếu chuỗi rỗng thì return "1"
            if (s.length === 0) return "1";

            const arr = s.split("").map((ch) => Number(ch));
            let carry = 1;
            for (let i = arr.length - 1; i >= 0 && carry; i--) {
                const sum = arr[i] + carry;
                arr[i] = sum % 10;
                carry = Math.floor(sum / 10);
            }
            if (carry) {
                // còn dư carry -> thêm vào đầu
                arr.unshift(carry);
            }
            return arr.join("");
        },
        ConnectCardReader() {
            let self = this;
            let arrCard = JSON.parse($app.readFile("CFG-DauDocThe.json")) || [];
            let checkId = null;
            let num = 0;
            self.conn.CardReaders().Status(function (id) {
                checkId = id;
                if (checkId) {
                    self.$Helper.ThongBaoToast(
                        "success",
                        "Kết nối đầu đọc thẻ " + (num + 1) + " thành công!"
                    );
                } else {
                    self.$Helper.ThongBaoToast(
                        "error",
                        "Kết nối đầu đọc thẻ " + (num + 1) + " thất bại!"
                    );
                }
                num++;
                // self.pingCardReader();
            });
            setTimeout(() => {
                arrCard.forEach((e) => {
                    self.conn.Connects("CardReader", e);
                });
            }, 0);
        },
        DisconnectCardReader() {
            let self = this;
            let arrCard = JSON.parse($app.readFile("CFG-DauDocThe.json")) || [];
            let list_id = {
                CardReader: [],
            };
            arrCard.forEach((e) => {
                list_id.CardReader.push(e.MaDauDocThe);
            });
            self.conn.DisConnects(list_id);
        },
        TaiMauExcel() {
            // Đường dẫn tuyệt đối đến file trong thư mục public
            const fileUrl = "/templates/ThemTheKiemSoat.xlsx";

            // Tạo thẻ <a> ẩn
            const link = document.createElement("a");
            link.href = fileUrl;
            link.download = "Mau_ThemTheKiemSoat.xlsx"; // tên file tải về
            document.body.appendChild(link);

            // Kích hoạt click để tải xuống
            link.click();

            // Dọn dẹp
            document.body.removeChild(link);
        },
        UploadExcel() {
            let validateNhomThe = this.$refs.formValidationNhomThe.instance.validate();
            if (!validateNhomThe.isValid) {
                return this.$Helper.Common.autoFocusError(validateNhomThe);
            }
            if (this.SuDungKyHieuTuDong) {
                let validate = this.$refs.formValidation.instance.validate();
                if (!validate.isValid) {
                    return this.$Helper.Common.autoFocusError(validate);
                }
            }
            const fileInput = document.getElementById("input-excel");
            if (fileInput) {
                fileInput.value = null; // Reset giá trị để có thể chọn lại cùng một file
                fileInput.click();
            }
        },
        OnChangeUploadExcel(event) {
            const file = event.target.files[0];
            if (!file) return;
            let self = this;
            const reader = new FileReader();
            reader.onload = async (e) => {
                const data = new Uint8Array(e.target.result);
                const workbook = XLSX.read(data, { type: "array" });

                // lấy sheet đầu tiên
                const sheetName = workbook.SheetNames[0];
                const sheet = workbook.Sheets[sheetName];
                console.log("🚀 ~ sheet:", sheet);
                let rows = [];
                // chuyển sang JSON
                rows = XLSX.utils.sheet_to_json(sheet, { defval: "" });
                rows = rows.map((obj) => Object.values(obj));
                rows.forEach(async (row) => {
                    let data = {
                        Id: self.$Helper.Common.randomGUID(),
                        TenNhomThe: self.NhomTheDangChon?.TenNhomThe,
                        IdNhomThe: self.ThongTinTheKiemSoat.IdNhomThe,
                        KyHieuThe: self.SuDungKyHieuTuDong
                            ? self.ThongTinTheKiemSoat.TienTo +
                              "-" +
                              self.ThongTinTheKiemSoat.HauTo
                            : row[1]
                            ? row[1].toString()
                            : "",
                        MaThe: row[0] ? row[0].toString() : "",
                    };
                    self.ThongTinTheKiemSoat.DanhSachTheKiemSoat.push(
                        self.$Helper.Common.CloneData(data)
                    );
                    if (self.SuDungKyHieuTuDong) {
                        self.ThongTinTheKiemSoat.HauTo = self.incrementNumericString(
                            self.ThongTinTheKiemSoat.HauTo
                        );
                    }
                });
                await new Promise((resolve) => setTimeout(resolve, 100));
                self.$refs.DanhSachTheKiemSoat.instance.refresh();
            };
            reader.readAsArrayBuffer(file);
        },
    },
    async created() {
        this.LayDanhSachNhomThe();
        let self = this;
        if (this.$Core?.App?.IsNative) {
            self.conn = new Devices();

            // Kết nối đầu đọc thẻ - start
            await new Promise((resolve) => setTimeout(resolve, 0));
            self.DisconnectCardReader();

            await new Promise((resolve) => setTimeout(resolve, 0));
            self.ConnectCardReader();

            await new Promise((resolve) => setTimeout(resolve, 0));
            self.conn.CardReaders().Scan(async function (MaThe) {
                self.ThucHienThemThe(MaThe);
            });
        }
    },
    mounted() {},
    beforeUnmount() {
        if (this.$Core?.App?.IsNative) {
            this.DisconnectCardReader();
        }
    },
};
</script>
<style scoped></style>
<style lang="scss" scoped></style>
